// loadMoreButtonをクリックしたときに、次のページを読み込む（Fastgenではなく、ShopifyのPagenationを利用）
function loadMoreProducts(event) {
  event.preventDefault();
  event.target.disabled = true;
  const productPageGroups = $('.products-page-group');
  if (!productPageGroups.length) {
    return;
  }
  const nextUrl = productPageGroups.last().data('next-url');
  if (nextUrl) {
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (data) {
        const newProducts = $(data).find('.products-page-group');
        productPageGroups.last().after(newProducts);
        // next-urlがない場合は、loadMoreButtonを非表示にする
        if (newProducts.length === 0 || !newProducts.last().data('next-url')) {
          $('#loadMoreButton').hide();
        }
        event.target.disabled = false;
      },
      error: function (data) {
        console.error('Error:', data);
        event.target.disabled = false;
      },
    });
  }
}
// 読み込んだ時
$(document).ready(function () {
  $('#loadMoreButton').on('click', function (event) {
    loadMoreProducts(event);
  });
});
